export default __webpack_public_path__ + "static/media/zasko.b3e23d22.png";